const params = [
  { programs: "Visual Communication", value: "SCOM" },
  { programs: "Digital Media", value: "SFDM" },
  { programs: "Undecided", value: "UNDE" },
];

export default params;
